module.exports = __webpack_public_path__ + "img/img12.d29b0eeb.svg";